import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";
import { Checkboxes } from '../../../FlowConfigurationInputs';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Returns     Component
 * @Author      Abdullah Onur Yeşil
 */
function WriteCell({ action, setOpenVariable, variables }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.EXCEL.WRITE-CELL.';
    const [rangeType, setRangeType] = useState(action.fields.rangeType?.value ? action.fields.rangeType.value : 'custom');

    useEffect(() => {
        // Assign initial values
        if (!action.fields.range) {
            action.fields.range = { value: '', isRequired: true };
        }
        if (!action.fields.rangeType || action.fields.rangeType?.value === '') {
            action.fields.rangeType = { value: 'custom' }
        }
        if (!action.fields.value) {
            action.fields.value = { value: '', isRequired: true };
        }
    }, [action]);

    function changeRangeType(v) {
        action.fields.rangeType = { value: v }
        setRangeType(v);
    }

    return (
        <>
            <div className="form-element">
                <div className="form-element">
                    {t(label + 'EXCEL-SOURCE')}
                    <VariablePicker action={action} inputName="excelSource" variables={variables}
                        setOpenVariable={setOpenVariable} filter="data table" isRequired />
                    <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
                </div>
            </div>
            <div className="form-element">
                {t(label + 'RANGE-TYPE')}
                <div className="condition-tabs">
                    <button
                        className={rangeType === 'custom' ? 'condition-active' : ''}
                        onClick={() => changeRangeType('custom')}>
                        {t(label + 'CUSTOM-RANGE')}
                    </button>
                    <button
                        className={rangeType === 'last' ? 'condition-active' : ''}
                        onClick={() => changeRangeType('last')}>
                        {t(label + 'ADD-TO-LAST-ROW')}
                    </button>
                </div>
                {t(rangeType === 'custom' ? label + 'RANGE' : label + 'COLUMN')}
                <TextInput action={action} inputName="range" variables={variables} setOpenVariable={setOpenVariable}
                    isRequired displayName={t(label + (rangeType === 'custom' ? 'RANGE' : 'COLUMN'))} fieldType={rangeType === 'custom' ? 'string-range' : "string-single-column"} />
                <em className="form-element-eg">{t(rangeType === 'custom' ? label + 'RANGE-EG' : label + 'COLUMN-EG')}</em>
            </div>
            <div className="form-element">
                <Checkboxes action={action} inputName="rowContainsIndex" options={{ label: label + 'ROW-CONTAINS-INDEX' }} />
            </div>
            <div className="form-element">
                {t(label + 'VALUE')}
                <TextInput action={action} inputName="value" variables={variables} setOpenVariable={setOpenVariable}
                    isRequired />
            </div>
        </>
    )
}

export default WriteCell;